import { InjectionToken, Type } from '@angular/core';

export const CONTENT_COMPONENTS = new InjectionToken<Type<unknown>[]>('blocks.contentComponents');
export const CONTENT_PREFORMATTERS = new InjectionToken<Type<unknown>[]>('blocks.contentPreformatters');
